<template>
    <div>
        <Escoger/>
    </div>
</template>
<script>
import Escoger from '@/components/zzHalloween/EscogerGrupos.vue'

export default {
    name: 'SolimanologEscoger',
    components:{
        Escoger
    },
    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

<style lang="scss" scoped>

</style>